import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Form, Select, Typography } from 'antd';
import { TrainingProjectsStore } from '../../stores';
import { trainingProjectFormFields, trainingProjectTaskTypeValues } from '../../misc/constants';

interface Props {
    store: TrainingProjectsStore;
}

const TrainingProjectTaskTypeSelect: React.FC<Props> = ({ store }) => {
    return (
        <>
            <Typography.Title level={5}>Task Type</Typography.Title>

            <Form.Item
                name={trainingProjectFormFields.taskType}
                initialValue={
                    store.editableTrainingProject
                        ? store.editableTrainingProject.taskType
                        : trainingProjectTaskTypeValues.JsonExtraction
                }
                rules={[{ required: true, message: 'Please select task type.' }]}
            >
                <Select
                    placeholder="Select task type"
                    options={[{ value: trainingProjectTaskTypeValues.JsonExtraction, label: 'JSON extraction' }]}
                />
            </Form.Item>
        </>
    );
};

export default observer(TrainingProjectTaskTypeSelect);
